import React from "react";
import { IMinimalBreadcrumb } from "../../../interfaces/breadcrumbs/breadcrumbs";



const MinimalBreadcrumb = ({ currentStep, totalSteps }: IMinimalBreadcrumb) => {
    const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

    return (
        <div className="minimal-breadcrumb">
            {steps.map((step) => {
                let className = "";

                if (step < currentStep) {
                    className = "completed-step";
                } else if (step === currentStep) {
                    className = "current-step";
                } else {
                    className = "not-started-breadcrumb";
                }

                return (
                    <div 
                        data-testid="minimal-breadcrumb"
                        key={step} 
                        className={`breadcrumb-step ${className}`} 
                    />
                )
            })}
        </div>
    );
};

export default MinimalBreadcrumb;